<template>
    <nav-bar :menuItems="menuItems" :portalButton="true" />
</template>
<script>
export default {
	name: "NavigationBarRisk",
	data: () => ({
		menuItems: [
			{ title: "Dashboard", link: "/risk/dashboard" },
			{ title: "Risk Definition", link: "/risk/riskdefinition" },
			{ title: "Risk Matrix", link: "/risk/riskpage#top" },
			{ title: "Action Plan", link: "/risk/riskpage#actionplan" },
			{ title: "Knowledge Page", link: "/risk/knowledgepage" },
			{ title: "ISO Process", link: "/risk/isoprocess" },
		],
		sidebar: false
	})
}
</script>